define([
    "./monitorableMapViewModule",
    "./monitorableMapViewDirective",
    "./monitorableMapView.less",
    "./modal/monitorableMapViewModal"
], function () {
});